import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckboxTile from '~/Common-Objects/UI/Forms/CheckboxTile'
import GroupSelector from '~/Common-Objects/UI/GroupSelector/GroupSelector'
import UpsellModal from '~/Common-Objects/UpsellModal'
import axios from '~/data/http/axios'
import FormPicker from '~/pages/cp/includes/formPicker'
import * as siteMaster from '~/data/actions/siteActions'
import i18n from '~/i18n'
import useTierAllowed from '~/Common-Objects/hooks/useTierAllowed'
import helpers from '~/Classes/helpers'

const FormGroupSelect = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { requiredTier, tierAllowed } = useTierAllowed('gatedContent')
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [formType, setFormType] = useState('form')
    const [upselling, setUpselling] = useState(false)

    const accountMaster = useSelector((state) => state.accountMaster)

    const handleChange = (type) => {
        if (type === 'form') {
            setFormType('form')
        } else if (type === 'gated') {
            if (tierAllowed) {
                setFormType('gated')
            } else {
                setUpselling(true)
                upsell('gatedContent')
                return
            }
        }
    }

    const upsell = (feature) => {
        const modal = (
            <UpsellModal
                feature={feature}
                requiredTier={requiredTier?.name}
                inline={true}
                onUpgrade={async () => {
                    dispatch(siteMaster.alterFullpage(null))
                }}
            />
        )
        dispatch(siteMaster.alterFullpage(modal))
    }

    const closeDrawer = useCallback(() => {
        dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
    }, [dispatch])

    const addForm = useCallback(() => {
        const formAdded = async (theme, themeType, options) => {
            if (!selectedGroup?.id) {
                console.warn('Selected group not set!')
                return
            }

            const form = {
                formName: '',
                wizard: { step1: true },
                options,
                ThemeId: theme.id,
                formType: themeType
            }

            const isUsingNewEditor = await helpers.getTemplateEditorVersion(accountMaster, true)

            return axios.post(`/group/${selectedGroup.id}/form`, form).then((response) => {
                const formId = response.data.Form.id

                const editorUrl = isUsingNewEditor.canUseV2
                    ? '/cp/templates/add/dragDropv2/'
                    : '/cp/templates/add/dragDrop/'

                const redirect = `/cp/groups/${selectedGroup.id}/forms/create/${formId}/2`
                history.push(
                    editorUrl +
                        `?form=true&groupId=${selectedGroup.id}&formId=${formId}&redirect=${encodeURIComponent(redirect)}`
                )
            })
        }

        const drawer = <FormPicker save={formAdded} formType={formType} groupId={selectedGroup.id} history={history} />
        dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, true, '100%', 'bg-main'))
    }, [dispatch, selectedGroup, formType, history])

    useEffect(() => {
        if (upselling) {
            setFormType('gated')
            setUpselling(false)
        }
    }, [tierAllowed])

    return (
        <div>
            <h4 className='mar-b10'>{i18n.t('form:groupSelect.header')}</h4>
            <p className='mar-b25'>{i18n.t('form:groupSelect.subHeader')}</p>

            <GroupSelector skipSettingDefaultGroup={true} groupChanged={(group) => setSelectedGroup(group)} />

            {selectedGroup && (
                <>
                    <div className='txtInput_label' style={{ marginBottom: 8 }}>
                        {i18n.t('form:groupSelect.type')}
                    </div>

                    <div className='row'>
                        <div className='col-xs-12 mar-b16'>
                            <CheckboxTile
                                name='formType'
                                value='form'
                                checked={formType === 'form'}
                                onChange={() => handleChange('form')}
                                data-ph={'form-create-form'}
                                outerStyle={{ height: '100%' }}
                                header={i18n.t('form:groupSelect.regularForm')}
                                subheader={i18n.t('form:groupSelect.regularFormDesc')}
                                icon='document'
                            />
                        </div>

                        <div className='col-xs-12'>
                            <CheckboxTile
                                name='formType'
                                value='gated'
                                checked={formType === 'gated'}
                                onChange={() => handleChange('gated')}
                                data-ph={tierAllowed.gatedContent ? 'form-create-gated' : 'form-create-gated-upsell'}
                                requiredTier={tierAllowed ? null : requiredTier?.name}
                                outerStyle={{ height: '100%' }}
                                header={i18n.t('form:groupSelect.gatedContent')}
                                subheader={i18n.t('form:groupSelect.gatedContentDesc')}
                                icon='inbox'
                            />
                        </div>
                    </div>

                    <div className='campaign-type-selector__sticky-footer mar-t20'>
                        <div className='campaign-type-selector__sticky-footer__content'>
                            <Button
                                disabled={false}
                                className='button-primary mar-r10 cyt-new-campaign-btn'
                                text={i18n.t('form:groupSelect.continue')}
                                onClick={addForm}
                            />
                            <Button onClick={closeDrawer}>{i18n.t('form:groupSelect.cancel')}</Button>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default FormGroupSelect
